import {Lightbulb} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import {useDungeonEditorSession} from "../shared/DungeonEditorSession.tsx";

export default function EditorLightingToggle() {
    const {activeLevel, lightingPreview, setLightingPreview} = useDungeonEditorSession();
    const enabled = Boolean(activeLevel?.map?.image && activeLevel.geometry.registration.calibrated);
    return <Button type="button" variant={lightingPreview ? "secondary" : "ghost"} size="sm"
        disabled={!enabled} aria-pressed={lightingPreview} title="Beleuchtung ohne Character-Sicht anzeigen"
        onClick={() => setLightingPreview(!lightingPreview)}><Lightbulb className="size-4"/> Lichtvorschau</Button>;
}
